// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.provider-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}

.provider-modal-container {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  max-width: 600px;
  width: 100%;
  margin: 0 20px;
  overflow: hidden;
}

.provider-modal-header {
  padding: 16px 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.provider-modal-logo {
  max-height: 40px;
  max-width: 200px;
  object-fit: contain;
}

.provider-modal-body {
  padding: 24px;
}

.provider-modal-text {
  text-align: center;
  margin-bottom: 24px;
  font-size: 16px;
  line-height: 1.5;
  color: #333333;
}

.provider-modal-buttons {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.provider-modal-button {
  padding: 12px 24px;
  border: none;
  border-radius: 4px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.provider-modal-button:hover {
  opacity: 0.9;
}

@media (max-width: 500px) {
  .provider-modal-container {
    max-width: 95%;
    margin: 0 10px;
  }
  
  .provider-modal-text {
    font-size: 14px;
  }
  
  .provider-modal-button {
    font-size: 13px;
    padding: 10px 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/provider-modal/provider-modal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":[".provider-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10000;\n}\n\n.provider-modal-container {\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);\n  max-width: 600px;\n  width: 100%;\n  margin: 0 20px;\n  overflow: hidden;\n}\n\n.provider-modal-header {\n  padding: 16px 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.provider-modal-logo {\n  max-height: 40px;\n  max-width: 200px;\n  object-fit: contain;\n}\n\n.provider-modal-body {\n  padding: 24px;\n}\n\n.provider-modal-text {\n  text-align: center;\n  margin-bottom: 24px;\n  font-size: 16px;\n  line-height: 1.5;\n  color: #333333;\n}\n\n.provider-modal-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.provider-modal-button {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 4px;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n}\n\n.provider-modal-button:hover {\n  opacity: 0.9;\n}\n\n@media (max-width: 500px) {\n  .provider-modal-container {\n    max-width: 95%;\n    margin: 0 10px;\n  }\n  \n  .provider-modal-text {\n    font-size: 14px;\n  }\n  \n  .provider-modal-button {\n    font-size: 13px;\n    padding: 10px 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
